// import React, { useState, useRef, useEffect } from "react";
// import "./dropdown.css";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function DropDown({
//   width,
//   label,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder, // Add placeholder prop
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState(placeholder || ""); // Initialize with placeholder
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   useEffect(() => {
//     setSelectedLabel(placeholder); // Update the selectedLabel when placeholder changes
//   }, [placeholder]);

//   const handleClick = (option) => {
//     setSelected(option.id);
//     setIsActive(false);
//     setSelectedLabel(option.label);
//   };

//   return (
//     <div className="dropdown" style={{ width }} ref={dropdownRef}>
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         onClick={() => setIsActive(!isActive)}
//         style={{ width: customWidth }}
//       >
//         {selectedLabel || placeholder} {/* Show placeholder if no selection */}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             height: Height,
//             overflow: OverFlow,
//             maxHeight: minheight,
//           }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item-dummy"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }








import React, { useState, useRef, useEffect } from "react";
import "./dropdown.css";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected, // Receive selected value from parent
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(placeholder || ""); // Initialize with placeholder
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  // Update the selectedLabel when the `selected` prop changes
  useEffect(() => {
    const selectedOption = options.find((option) => option.id === selected);
    if (selectedOption) {
      setSelectedLabel(selectedOption.label);
    } else {
      setSelectedLabel(placeholder); // Reset to placeholder if no selection
    }
  }, [selected, options, placeholder]); // Watch for changes in `selected`, `options`, and `placeholder`

  const handleClick = (option) => {
    setSelected(option.id); // Pass the selected ID to parent
    setIsActive(false);
    setSelectedLabel(option.label); // Update the label internally
  };

  return (
    <div className="dropdown" style={{ width }} ref={dropdownRef}>
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={() => setIsActive(!isActive)}
        style={{ width: customWidth }}
      >
        {selectedLabel || placeholder} {/* Show placeholder if no selection */}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            height: Height,
            overflow: OverFlow,
            maxHeight: minheight,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-dummy"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}





















// import React, { useState, useRef, useEffect } from "react";
// import "./dropdown.css";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

// export default function DropDown({
//   width,
//   label,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabels, setSelectedLabels] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredOptions, setFilteredOptions] = useState(options);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   useEffect(() => {
//     setFilteredOptions(
//       options.filter(option =>
//         option.label.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   }, [searchTerm, options]);

//   const handleCheckboxChange = (option) => {
//     const selectedIds = selectedLabels.map((item) => item.id);
//     let newSelected;

//     if (option.id === "all") {
//       if (selectedIds.includes("all")) {
//         newSelected = [];
//       } else {
//         newSelected = [{ id: "all", label: "All" }, ...options];
//       }
//     } else {
//       newSelected = selectedIds.includes(option.id)
//         ? selectedLabels.filter((item) => item.id !== option.id)
//         : [...selectedLabels.filter(item => item.id !== "all"), option];
//     }

//     setSelectedLabels(newSelected);
//     setSelected(newSelected.map(item => item.id));
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setIsActive(true);
//   };

//   const handleDropdownToggle = () => {
//     setIsActive(!isActive);
//   };

//   return (
//     <div className="dropdown" style={{ width }} ref={dropdownRef}>
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         style={{ width: customWidth }}
//       >
//         <input
//           type="text"
//           placeholder={placeholder}
//           value={searchTerm}
//           onChange={handleSearchChange}
//           onClick={handleDropdownToggle}
//           className="dropdown-input"
//         />
//         <img src={DropDownIcon} alt="dropdown-icon" onClick={handleDropdownToggle} />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             height: Height,
//             overflow: OverFlow,
//             maxHeight: minheight,
//           }}
//         >
//           <div className="dropdown-item">
//             <input
//               type="checkbox"
//               id="all"
//               checked={selectedLabels.map(item => item.id).includes("all")}
//               onChange={() => handleCheckboxChange({ id: "all", label: "All" })}
//             />
//             <label htmlFor="all">All</label>
//           </div>
//           {filteredOptions.map((option) => (
//             <div key={option.id} className="dropdown-item">
//               <input
//                 type="checkbox"
//                 id={option.id}
//                 checked={selectedLabels.map(item => item.id).includes(option.id)}
//                 onChange={() => handleCheckboxChange(option)}
//               />
//               <label htmlFor={option.id}>{option.label}</label>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

